/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Type_DefaultInputs */



/**
* | output |
* | --- |
* | "Default" |
*
* @param {New_Project_Type_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_type_default = /** @type {((inputs?: New_Project_Type_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Type_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par defaut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standard")
	if (locale === "it") return /** @type {LocalizedString} */ ("Predefinito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("По умолчанию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por defecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("默认")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デフォルト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गलती करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Padrão")
	return /** @type {LocalizedString} */ ("Default")
});